import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useFundingCta } from "./FundingCta";

/**
 * On a phone the page is a long read, so the one thing we want them to do follows them down it.
 * It appears once they're past the hero and gets out of the way when the closing CTA arrives.
 */
export default function FundingStickyCta() {
  const { applyHref, openDesk, mode } = useFundingCta();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const close = document.querySelector('[data-testid="funding-close"]');
      const cookies = document.querySelector('[data-testid="cookie-consent"]');   // it sits in the same corner
      const pastHero = window.scrollY > 620;
      const closeInView = close ? close.getBoundingClientRect().top < window.innerHeight - 60 : false;
      setShow(pastHero && !closeInView && !cookies);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const watch = new MutationObserver(onScroll);          // so it appears the moment cookies are dismissed
    watch.observe(document.body, { childList: true, subtree: true });
    return () => { window.removeEventListener("scroll", onScroll); watch.disconnect(); };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 96 }} animate={{ y: 0 }} exit={{ y: 96 }}
          transition={{ type: "spring", stiffness: 320, damping: 30 }}
          className="sm:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-[#070C16]/95 backdrop-blur-md px-4 pt-3 pb-[max(0.85rem,env(safe-area-inset-bottom))]"
          data-testid="funding-sticky-cta">
          <div className="flex items-center gap-2.5">
            {applyHref ? (
              <Link to={applyHref} data-testid="funding-sticky-apply"
                    className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#0055FF] active:bg-[#0044CC] text-white text-[14.5px] font-semibold">
                {mode === "resume" ? "Continue your application" : "Start your application"}
                <ArrowRight className="size-4" />
              </Link>
            ) : (
              <button onClick={openDesk} data-testid="funding-sticky-desk"
                      className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#0055FF] active:bg-[#0044CC] text-white text-[14.5px] font-semibold">
                Speak to the funding desk
                <ArrowRight className="size-4" />
              </button>
            )}
          </div>
          <p className="mt-2 text-center text-[10.5px] text-slate-500">
            £25k to £500m+ · no credit search to apply · nothing to pay us
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
